"use strict";

define('rs/form/formpdf/formpdf.controller',['rs/form/form.controller', 'rs/form/formpdf/formpdf.view', 'rs/helper', 'moment'], function (FormController, FormPDFView, helper, moment) {
  var FormPDFContoller = FormController.extend({
    properties: [],
    activateSection: function activateSection(section) {
      var sections = this.getVisibleSections();
      for (var s = 0; s < sections.length; s++) {
        sections[s].show();
      }
      return Promise.resolve();
    },
    canEditDocument: function canEditDocument() {
      return false;
    },
    getTemplateProperties: function getTemplateProperties() {
      var documentModel = this.getDocumentModel(),
        templateModel = this.getTemplateModel(),
        assignmentsMap = this.getAssignments().getMap();
      return {
        createDate: documentModel.createDate ? moment(documentModel.createDate).format('l') : null,
        doc: documentModel,
        status: helper.toProperCase(documentModel.status),
        template: templateModel,
        assignments: assignmentsMap
      };
    },
    isPDFMode: function isPDFMode() {
      return true;
    },
    setupView: function setupView() {
      this.setView(new FormPDFView());
    },
    shouldRenderFooter: function shouldRenderFooter() {
      return false;
    }
  });
  return FormPDFContoller;
});

